import { ThemeContext } from '@/providers/ThemeProvider/contexts';
import type { ThemePreferenceType } from '@/styles/types';
import { useContext } from 'react';

export const useThemeContext = (): {
  value: ThemePreferenceType;
  onChange: (theme: ThemePreferenceType) => void;
  isPending: boolean;
  hasSyncError: boolean;
  retrySync: () => void;
} => {
  const { value, onChange, isPending, hasSyncError, retrySync } =
    useContext(ThemeContext);

  const handleChange = (theme: ThemePreferenceType): void => {
    onChange(theme);
  };

  return {
    value,
    onChange: handleChange,
    isPending,
    hasSyncError,
    retrySync,
  };
};
